import api from '../../api';
import config from '../../config';
// const { DOMAIN_KEY } = process.env;
export default {
    post: (data, headers=null) => {
        return api.request('post',config.default.videoCreate, headers, null, data)
    }
}